

// import { useState, useEffect, useCallback } from 'react';
// import { getStudy, submitSurvey, saveSurveyDraft } from '../../../../Config/api';
// import { calculateFormProgress } from '../ProgressCalculator';

// export const useSurveyForm = (userId, studyId, subject) => {
//     const [studyData, setStudyData] = useState(null);
//     const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
//     const [formData, setFormData] = useState({});
//     const [isSubmitting, setIsSubmitting] = useState(false);
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [isLoading, setIsLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [hasConsented, setHasConsented] = useState(true);
//     const [isSavingDraft, setIsSavingDraft] = useState(false);
//     const [lastSaveTime, setLastSaveTime] = useState(null);
//     const [isEligible, setIsEligible] = useState(true);

//     const autoSaveDraft = useCallback(async (data, sectionIndex, consented, eligible = true) => {
//         if (isSubmitted) return;

//         try {
//             setIsSavingDraft(true);

//             const completionPercentage = calculateFormProgress(studyData, data);

//             const draftData = {
//                 ...data,
//                 currentSectionIndex: sectionIndex,
//                 hasConsented: consented,
//                 isEligible: eligible,
//                 lastSaved: new Date().toISOString(),
//                 progress: completionPercentage,
//                 subjectId: subject?.subjectId,
//                 siteId: subject?.siteId
//             };

//             await saveSurveyDraft(userId, studyId, draftData);
//             setLastSaveTime(new Date());
//         } catch (error) {
//             console.error('Auto-save failed:', error);
//         } finally {
//             setIsSavingDraft(false);
//         }
//     }, [userId, studyId, isSubmitted, studyData, subject]);

//     const fetchStudyData = useCallback(async () => {
//         if (!userId || !studyId) {
//             setIsLoading(false);
//             setError('Missing required parameters');
//             return;
//         }

//         try {
//             setIsLoading(true);
//             setError(null);

//             const payload = {
//                 studyId: Number(studyId),
//                 userId: Number(userId),
//                 subjectId: subject?.subjectId ? Number(subject.subjectId) : null,
//                 siteid: subject?.siteId ? Number(subject.siteId) : null
//             };

//             const response = await getStudy(payload);

//             const responseData = response?.data?.study_definition?.[0]?.study_definition?.data;
//             const submissionStatus = responseData?.status || response?.data?.status;

//             if (submissionStatus === 'submitted' || submissionStatus === 'completed') {
//                 setIsSubmitted(true);
//                 setIsLoading(false);
//                 return;
//             }

//             let studyDef = responseData?.study_definition;

//             if (!studyDef) {
//                 studyDef = response?.data?.study_definition[0].study_definition.study_definition;
//             }

//             console.log('Study Definition:', studyDef);

//             if (Array.isArray(studyDef) && studyDef.length > 0) {
//                 studyDef = studyDef[0];
//             }

//             if (studyDef && typeof studyDef === 'object' && studyDef.study_definition) {
//                 studyDef = studyDef.study_definition;
//             }

//             if (typeof studyDef === 'string') {
//                 studyDef = JSON.parse(studyDef);
//             }

//             const study = studyDef;

//             if (!study || !study.sections || !Array.isArray(study.sections)) {
//                 throw new Error('Invalid study structure: sections not found');
//             }

//             const filteredStudy = {
//                 ...study,
//                 sections: study.sections.filter(section => section.id !== 'consent')
//             };

//             setStudyData(filteredStudy);

//             const draftResp = responseData?.draft_response || response?.data?.draft_response || response?.data?.study_definition?.[0]?.draft_response;
//             if (draftResp) {
//                 const draft = typeof draftResp === 'string' ? JSON.parse(draftResp) : draftResp;
//                 const { currentSectionIndex: savedSection, hasConsented: savedConsent, isEligible: savedEligible, lastSaved, progress, subjectId, siteId, ...savedFormData } = draft;

//                 setFormData(savedFormData);

//                 if (typeof savedSection === 'number' && savedSection >= 0) {
//                     setCurrentSectionIndex(savedSection);
//                 }

//                 if (savedConsent) {
//                     setHasConsented(true);
//                 }

//                 if (savedEligible !== undefined) {
//                     setIsEligible(savedEligible);
//                 }
//             }
//         } catch (err) {
//             console.error('Error fetching study data:', err);
//             setError(err.message);
//         } finally {
//             setIsLoading(false);
//         }
//     }, [userId, studyId, subject]);

//     const updateFormData = (data) => {
//         setFormData(prev => ({ ...prev, ...data }));
//     };

//     const validateAllSections = useCallback(() => {
//         const incompleteSections = [];

//         if (!isEligible) {
//             const firstSection = studyData.sections[0];
//             const lastSection = studyData.sections[studyData.sections.length - 1];

//             [firstSection, lastSection].forEach((section, idx) => {
//                 const actualIndex = idx === 0 ? 0 : studyData.sections.length - 1;

//                 const validateQuestions = (questions) => {
//                     questions.forEach(question => {
//                         if (question.type === 'group' && question.questions) {
//                             validateQuestions(question.questions);
//                         } else if (question.required) {
//                             const value = formData[question.id];
//                             if (!value || (Array.isArray(value) && value.length === 0) || value === '') {
//                                 if (!incompleteSections.includes(actualIndex)) {
//                                     incompleteSections.push(actualIndex);
//                                 }
//                             }
//                         }
//                     });
//                 };

//                 validateQuestions(section.questions);
//             });
//         } else {
//             studyData.sections.forEach((section, index) => {
//                 const validateQuestions = (questions) => {
//                     questions.forEach(question => {
//                         if (question.type === 'group' && question.questions) {
//                             validateQuestions(question.questions);
//                         } else if (question.required) {
//                             const value = formData[question.id];
//                             if (!value || (Array.isArray(value) && value.length === 0) || value === '') {
//                                 if (!incompleteSections.includes(index)) {
//                                     incompleteSections.push(index);
//                                 }
//                             }
//                         }
//                     });
//                 };

//                 validateQuestions(section.questions);
//             });
//         }

//         return incompleteSections;
//     }, [studyData, formData, isEligible]);

//     const handleSubmit = async () => {
//         if (isSubmitted) {
//             return { success: false, error: 'Survey already submitted' };
//         }

//         setIsSubmitting(true);

//         try {
//             const submissionData = {
//                 ...formData,
//                 submittedAt: new Date().toISOString(),
//                 progress: 100,
//                 isEligible: isEligible,
//                 subjectId: subject?.subjectId,
//                 siteId: subject?.siteId
//             };

//             const response = await submitSurvey(userId, studyId, submissionData);

//             if (response.success) {
//                 setIsSubmitted(true);
//                 return { success: true };
//             } else {
//                 if (response.error && response.error.includes('Duplicate entry')) {
//                     setIsSubmitted(true);
//                     return { success: false, error: 'This survey has already been submitted.' };
//                 }
//                 throw new Error(response.message || response.error || 'Submission failed');
//             }
//         } catch (error) {
//             if (error.message && error.message.includes('Duplicate entry')) {
//                 setIsSubmitted(true);
//                 return { success: false, error: 'This survey has already been submitted.' };
//             }
//             return { success: false, error: error.message };
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     useEffect(() => {
//         fetchStudyData();
//     }, [fetchStudyData]);

//     useEffect(() => {
//         if (isSubmitted || isLoading || !studyData || Object.keys(formData).length === 0) return;

//         const timeoutId = setTimeout(() => {
//             autoSaveDraft(formData, currentSectionIndex, hasConsented, isEligible);
//         }, 2000);

//         return () => clearTimeout(timeoutId);
//     }, [formData, currentSectionIndex, hasConsented, isEligible, autoSaveDraft, isLoading, studyData, isSubmitted]);

//     return {
//         studyData,
//         currentSectionIndex,
//         setCurrentSectionIndex,
//         formData,
//         updateFormData,
//         isSubmitting,
//         isSubmitted,
//         isLoading,
//         error,
//         hasConsented,
//         setHasConsented,
//         isEligible,
//         setIsEligible,
//         isSavingDraft,
//         lastSaveTime,
//         autoSaveDraft,
//         validateAllSections,
//         handleSubmit,
//         completionPercentage: calculateFormProgress(studyData, formData)
//     };
// };

import { useState, useEffect, useCallback } from 'react';
import { getStudy, submitSurvey, saveSurveyDraft } from '../../../../Config/api';
import { calculateFormProgress } from '../ProgressCalculator';

export const useSurveyForm = (userId, studyId, subject) => {
    console.log('=== USESURVEYFORM HOOK ===');
    console.log('Received studyId:', studyId);
    console.log('Received userId:', userId);
    console.log('Received subject:', subject);
    console.log('==========================');

    const [studyData, setStudyData] = useState(null);
    const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
    const [formData, setFormData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [hasConsented, setHasConsented] = useState(true);
    const [isSavingDraft, setIsSavingDraft] = useState(false);
    const [lastSaveTime, setLastSaveTime] = useState(null);
    const [isEligible, setIsEligible] = useState(true);

    const autoSaveDraft = useCallback(async (data, sectionIndex, consented, eligible = true) => {
        if (isSubmitted) return;

        try {
            setIsSavingDraft(true);

            const completionPercentage = calculateFormProgress(studyData, data);

            const draftData = {
                ...data,
                currentSectionIndex: sectionIndex,
                hasConsented: consented,
                isEligible: eligible,
                lastSaved: new Date().toISOString(),
                progress: completionPercentage,
            };

            await saveSurveyDraft(userId, studyId, subject.siteId, subject.subjectId, draftData);
            setLastSaveTime(new Date());
        } catch (error) {
            console.error('Auto-save failed:', error);
        } finally {
            setIsSavingDraft(false);
        }
    }, [userId, studyId, isSubmitted, studyData, subject]);

    const fetchStudyData = useCallback(async () => {
        if (!userId || !studyId) {
            setIsLoading(false);
            setError('Missing required parameters');
            return;
        }

        try {
            setIsLoading(true);
            setError(null);

            console.log('=== FETCH STUDY DATA ===');
            console.log('studyId:', studyId);
            console.log('studyId type:', typeof studyId);
            console.log('userId:', userId);
            console.log('subject:', subject);

            const payload = {
                studyId: Number(subject.studyId),
                userId: Number(userId),
                subjectId: subject?.subjectId ? Number(subject.subjectId) : null,
                siteid: subject?.siteId ? Number(subject.siteId) : null
            };

            console.log('Payload to send:', payload);
            console.log('========================');

            const response = await getStudy(payload);

            console.log('API Response:', response);

            const responseData = response?.data?.study_definition?.[0]?.study_definition?.data;
            const submissionStatus = responseData?.status || response?.data?.status;

            if (submissionStatus === 'submitted' || submissionStatus === 'completed') {
                setIsSubmitted(true);
                setIsLoading(false);
                return;
            }

            // SIMPLIFIED PARSING
            let studyDef = response?.data?.study_definition?.[0]?.study_definition?.study_definition;

            console.log('=== STUDY DEF BEFORE PARSING ===');
            console.log('Type:', typeof studyDef);
            console.log('Value:', studyDef);
            console.log('================================');

            // If it's a string, parse it
            if (typeof studyDef === 'string') {
                try {
                    studyDef = JSON.parse(studyDef);
                    console.log('Parsed from string');
                } catch (e) {
                    console.error('JSON parse error:', e);
                    throw new Error('Failed to parse study definition');
                }
            }

            // If it's an array, get first element
            if (Array.isArray(studyDef)) {
                studyDef = studyDef[0];
                console.log('Extracted from array');
            }

            console.log('=== FINAL STUDY DEF ===');
            console.log('Study definition:', studyDef);
            console.log('Sections:', studyDef?.sections);
            studyDef?.sections?.forEach((s, i) => {
                console.log(`Section ${i} (${s.id}): ${s.questions?.length} questions`);
            });
            console.log('=======================');

            if (!studyDef || !studyDef.sections || !Array.isArray(studyDef.sections)) {
                throw new Error('Invalid study structure: sections not found');
            }

            const filteredStudy = {
                ...studyDef,
                sections: studyDef.sections.filter(section => section.id !== 'consent')
            };

            console.log('=== FILTERED STUDY ===');
            filteredStudy.sections.forEach((s, i) => {
                console.log(`Section ${i} (${s.id}): ${s.questions?.length} questions`);
            });
            console.log('======================');

            setStudyData(filteredStudy);

            const draftResp = responseData?.draft_response || response?.data?.draft_response || response?.data?.study_definition?.[0]?.draft_response;
            if (draftResp) {
                const draft = typeof draftResp === 'string' ? JSON.parse(draftResp) : draftResp;
                const { currentSectionIndex: savedSection, hasConsented: savedConsent, isEligible: savedEligible, lastSaved, progress, subjectId, siteId, ...savedFormData } = draft;

                setFormData(savedFormData);

                if (typeof savedSection === 'number' && savedSection >= 0) {
                    setCurrentSectionIndex(savedSection);
                }

                if (savedConsent) {
                    setHasConsented(true);
                }

                if (savedEligible !== undefined) {
                    setIsEligible(savedEligible);
                }
            }
        } catch (err) {
            console.error('=== ERROR DETAILS ===');
            console.error('Error message:', err.message);
            console.error('Error object:', err);
            console.error('Stack trace:', err.stack);
            console.error('====================');
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    }, [userId, studyId, subject]);

    const updateFormData = (data) => {
        setFormData(prev => ({ ...prev, ...data }));
    };

    const validateAllSections = useCallback(() => {
        const incompleteSections = [];

        if (!isEligible) {
            const firstSection = studyData.sections[0];
            const lastSection = studyData.sections[studyData.sections.length - 1];

            [firstSection, lastSection].forEach((section, idx) => {
                const actualIndex = idx === 0 ? 0 : studyData.sections.length - 1;

                const validateQuestions = (questions) => {
                    questions.forEach(question => {
                        if (question.type === 'group' && question.questions) {
                            validateQuestions(question.questions);
                        } else if (question.required) {
                            const value = formData[question.id];
                            if (!value || (Array.isArray(value) && value.length === 0) || value === '') {
                                if (!incompleteSections.includes(actualIndex)) {
                                    incompleteSections.push(actualIndex);
                                }
                            }
                        }
                    });
                };

                validateQuestions(section.questions);
            });
        } else {
            studyData.sections.forEach((section, index) => {
                const validateQuestions = (questions) => {
                    questions.forEach(question => {
                        if (question.type === 'group' && question.questions) {
                            validateQuestions(question.questions);
                        } else if (question.required) {
                            const value = formData[question.id];
                            if (!value || (Array.isArray(value) && value.length === 0) || value === '') {
                                if (!incompleteSections.includes(index)) {
                                    incompleteSections.push(index);
                                }
                            }
                        }
                    });
                };

                validateQuestions(section.questions);
            });
        }

        return incompleteSections;
    }, [studyData, formData, isEligible]);

    const handleSubmit = async () => {
        if (isSubmitted) {
            return { success: false, error: 'Survey already submitted' };
        }

        setIsSubmitting(true);

        try {
            const submissionData = {
                ...formData,
                submittedAt: new Date().toISOString(),
                progress: 100,
                isEligible: isEligible,
                // subjectId: subject?.subjectId,
                // siteId: subject?.siteId
            };

            const response = await submitSurvey(userId, studyId, subject?.siteId, subject?.subjectId, submissionData);

            if (response.success) {
                setIsSubmitted(true);
                return { success: true };
            } else {
                if (response.error && response.error.includes('Duplicate entry')) {
                    setIsSubmitted(true);
                    return { success: false, error: 'This survey has already been submitted.' };
                }
                throw new Error(response.message || response.error || 'Submission failed');
            }
        } catch (error) {
            if (error.message && error.message.includes('Duplicate entry')) {
                setIsSubmitted(true);
                return { success: false, error: 'This survey has already been submitted.' };
            }
            return { success: false, error: error.message };
        } finally {
            setIsSubmitting(false);
        }
    };

    useEffect(() => {
        fetchStudyData();
    }, [fetchStudyData]);

    useEffect(() => {
        if (isSubmitted || isLoading || !studyData || Object.keys(formData).length === 0) return;

        const timeoutId = setTimeout(() => {
            autoSaveDraft(formData, currentSectionIndex, hasConsented, isEligible);
        }, 2000);

        return () => clearTimeout(timeoutId);
    }, [formData, currentSectionIndex, hasConsented, isEligible, autoSaveDraft, isLoading, studyData, isSubmitted]);

    return {
        studyData,
        currentSectionIndex,
        setCurrentSectionIndex,
        formData,
        updateFormData,
        isSubmitting,
        isSubmitted,
        isLoading,
        error,
        hasConsented,
        setHasConsented,
        isEligible,
        setIsEligible,
        isSavingDraft,
        lastSaveTime,
        autoSaveDraft,
        validateAllSections,
        handleSubmit,
        completionPercentage: calculateFormProgress(studyData, formData)
    };
};